// @core/api/endpoints/project/add_project_member.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddProjectMemberRequest,
  ProjectMemberResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Add project member
 * Adds a user as a project member with the specified role. The new member gains access to project boards, items, and sprints according to their role.
 */
export async function AddProjectMember(
  project_id: string,
  data: AddProjectMemberRequest,
  options?: RequestOptions
): Promise<ProjectMemberResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/members`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.post<ProjectMemberResponse>(requestPath, data, requestOptions);
}
